import { HttpBackend, HttpClient, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import { IFileUploadObject } from 'src/app/shared/components/file-uploader/file-upload-object.interface';
import { OrderTypeEnum } from 'src/app/shared/interfaces/OrderTypeEnum';
import { GetEDIAttachment, SaveEDIAttachments, SetFileLoadingState, UpdateUploadedAttachment } from 'src/app/shared/states/orders/orders.actions';
import { OrdersState } from 'src/app/shared/states/orders/orders.state';
import { IUploadFileToS3Response } from '../../interfaces/upload-file-result.interface';

@UntilDestroy()
@Injectable()
export class OrdersService {
  // @Select(OrdersState.recentRequestedAttachmentURL) recentRequestedAttachmentURL$: Observable<string | undefined>;
  // @Select(OrdersState.orderFiles) orderFiles$: Observable<IFileUploadObject[]>;

  // private httpClient: HttpClient;

  // constructor(
  //   httpBackend: HttpBackend,
  //   private store: Store,
  // ) {
  //   this.httpClient = new HttpClient(httpBackend);
  // }

  // saveAttachmentsList(payload, isEditMode: boolean, alreadyAttached: IFileUploadObject[], attachments?: IFileUploadObject[]): void {
  //   if (!isEditMode) {
  //     attachments?.map(x => x.orderId = payload?.orderId);
  //   }
  //   if (attachments) {
  //     this.store.dispatch(new SaveEDIAttachments(
  //       isEditMode ?
  //         attachments :
  //         [...alreadyAttached ?? [], ...attachments], payload
  //     ))
  //       .pipe(untilDestroyed(this), withLatestFrom(this.orderFiles$))
  //       .subscribe(([_, orderFiles]: [any, IFileUploadObject[]]) => {
  //         this.uploadFiles(orderFiles);
  //       });
  //   }
  // }


  // downloadFile(item: IFileUploadObject): void {
  //   this.store.dispatch(new GetEDIAttachment({id: item.id, name: item.name}))
  //     .pipe(untilDestroyed(this), withLatestFrom(this.recentRequestedAttachmentURL$))
  //     .subscribe(([_, url]) => {
  //       window.open(url, '_blank');
  //     });

  // }

  // private uploadFileAWSS3(fileuploadurl, file: File): Observable<any> {
  //   const headers = new HttpHeaders({'Content-Type': 'multipart/form-data'});
  //   const req = new HttpRequest(
  //     'PUT',
  //     fileuploadurl,
  //     file,
  //     {headers}
  //   );

  //   return this.httpClient.request(req);
  // }

  // private uploadFiles(files: IFileUploadObject[]): void {
  //   files.forEach(file => {
  //     const stateFile = this.store.selectSnapshot(OrdersState.orderFiles)?.find(x => x.id === file.id);
  //     if (!stateFile.isUploading && !stateFile.uploadCompleted && file.downloadUrl && file.selectedFile) {
  //       this.store.dispatch(new SetFileLoadingState(file.id));
  //       console.log(stateFile)
  //       this.uploadFileAWSS3(file.downloadUrl, file.selectedFile)
  //         .pipe(untilDestroyed(this))
  //         .subscribe((res: IUploadFileToS3Response) => {
  //           if (res.type  === HttpEventType.Response) {
  //             this.store.dispatch(new UpdateUploadedAttachment(file.id))
  //           }
  //           if (res.error) {
  //             console.error(res.error);
  //           }
  //         });
  //     }
  //   });
  // }

  public navigateToOrderDetails(router: Router, orderType: OrderTypeEnum, orderId: string, drugName?: string): void {
    switch (orderType) {
      case OrderTypeEnum.SaleToProvider: {
          router.navigate(['/inventory/sales-to-providers-history', orderId], {state : {navigatedFrom: router.url, drugName}});
          break;
      }
      case OrderTypeEnum.SaleToReverseDistributor: {
          router.navigate(['/inventory/sales-to-reverse-distributors-history', orderId], {state : {navigatedFrom: router.url, drugName}});
          break;
      }
      case OrderTypeEnum.ReturnToWholesaler: {
          router.navigate(['/inventory/returns-to-wholesalers-history', orderId], {state : {navigatedFrom: router.url, drugName}});
          break;
      }
      case OrderTypeEnum.Destruction: {
          router.navigate(['/inventory/inventory-destructions-history', orderId], {state : {navigatedFrom: router.url, drugName}});
          break;
      }
      default: {
          router.navigate(['inventory/order-history/details', orderId], {state : {
            navigatedFrom: router.url,
            drugName
          }
        });
      }
    }
  }
}
